module.exports = __webpack_public_path__ + "static/media/square-shapes.bd031743.svg";